import { useFlags as useOriginalFeatureFlags } from "@edgetier/feature-flags";
import { FEATURE_FLAGS } from "types-for/feature-flags";

const useFlags = useOriginalFeatureFlags<FEATURE_FLAGS>;

export default useFlags;
